<template>
    <div id="login-change">
        <div v-if="isLoggedIn">
            <a :href="$ceres.urls.myAccount" :title="$translate('Ceres::Template.loginMyAccount')" id="accountMenuList" data-boundary="window">
				<svg width="20" height="20" class="header-controls__icon"><use xlink:href="#svg_user" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>
				<span>{{$translate('Ceres::Template.loginMyAccount')}}</span>
            </a>
        </div>
        <div v-if="!isLoggedIn">
            <a data-toggle="modal" :href="isLogin ? 'javascript:void(0)' : '#login'" title="Login" @click="createLoginModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.login')">
            	<svg width="20" height="20" class="header-controls__icon"><use xlink:href="#svg_user" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>
				<span>{{$translate('Ceres::Template.login')}}</span>
			</a>
        </div>
    </div>
</template>

<script>
import ApiService from "ceres/app/services/ApiService";
import ValidationService from "ceres/app/services/ValidationService";
import { isDefined } from "ceres/app/helper/utils";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    created()
    {
        ApiService.get("/rest/io/customer", {}, { keepOriginalResponse: true })
            .done(response =>
            {
                if (isDefined(response.data))
                {
                    this.$store.commit("setUserData", response.data);
                }
            });

        this.isLogin = App.templateType === "login";
        this.isRegister = App.templateType === "register";
    },

    /**
     * Add the global event listener for login and logout
     */
    mounted()
    {
        this.$nextTick(() =>
        {
            this.addEventListeners();
        });
    },

    methods: {
        /**
         * Adds login/logout event listeners
         */
        addEventListeners()
        {
            ApiService.listen("AfterAccountAuthentication", userData =>
            {
                this.$store.commit("setUserData", userData.accountContact);
            });

            ApiService.listen("AfterAccountContactLogout", () =>
            {
                this.$store.commit("setUserData", null);
            });
        },

        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");

        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
